import SettingToggle from "./SettingToggle";
import {useContext} from "react";
import {MapContext} from "../context/MapContext";
import ActionButton from "./ActionButton";
import {CloseCircle} from "reicon-react";

const SettingsPanel = () => {
  const {
    servicesSetting,
    setServicesSetting,
    accessSetting,
    setAccessSetting,
    currentLocation,
    setCurrentLocation,
    setShowSettings,
    setScenariesSetting,
    scenariesSetting,
    zonesSetting,
    setZonesSetting,
  } = useContext(MapContext)

  return (
    <section className="settings-panel">
      <header className="header">
        <div>
          <h2>Filtros</h2>
          <p>Elige qué elementos quieres ver en el mapa.</p>
        </div>
        <ActionButton
          className="panel-action-button"
          onClick={() => setShowSettings(false)}
          icon={CloseCircle}
          label="Cerrar filtros"/>
      </header>
      <SettingToggle
        checked={scenariesSetting}
        storage="scenariesSetting"
        onChange={setScenariesSetting}
        text="Escenarios"
      />
      <SettingToggle
        checked={servicesSetting}
        storage="servicesSetting"
        onChange={setServicesSetting}
        text="Servicios y amenidades"
      />
      <SettingToggle
        checked={accessSetting}
        storage="accessSetting"
        onChange={setAccessSetting}
        text="Accesos"
      />
      <SettingToggle
        checked={zonesSetting}
        storage="zonesSetting"
        onChange={setZonesSetting}
        text="Zonas"
      />
      <SettingToggle
        checked={currentLocation}
        storage="currentLocation"
        onChange={setCurrentLocation}
        text="Mi ubicación"
      />
    </section>
  );
};

export default SettingsPanel;
